import { initFetchStrapiJSON } from '@betterpool/strapi-client';

export const fetchStrapiJSON = initFetchStrapiJSON({
  env: process.env.NEXT_PUBLIC_ENV,
  url: process.env.NEXT_PUBLIC_STRAPI_API_URL,
  key: process.env.NEXT_PUBLIC_STRAPI_API_KEY,
});
